// Resume PDF URL
export const RESUME_URL = "/Resume_NakshtraYadav.pdf";

// Personal Info
export const personalInfo = {
  name: "Nakshtra Yadav",
  initials: "NY",
  title: "IT Systems Administrator",
  subtitle: "Network & Cloud Infrastructure Specialist",
  tagline: "IT professional with 3+ years of experience in systems administration, network engineering, and cloud environments.",
  valueProposition: "Building secure, scalable enterprise infrastructure — from cloud architecture to PowerShell automation.",
  email: "contact@nakshtrayadav.com",
  location: "Melbourne, Australia",
  phone: "+61 407 777 686",
  linkedin: "https://www.linkedin.com/in/nakshtrayadav/",
  github: "https://github.com/NakshtraYadav/",
};

// About Stats
export const aboutStats = [
  { label: "Years Experience", value: "3+" },
  { label: "Certifications", value: "3" },
  { label: "Cloud Platforms", value: "5+" },
];

export const aboutSummary = "IT professional specializing in Microsoft 365, Azure, infrastructure security, and automation using PowerShell. Experienced in managing enterprise-level environments, implementing backup and disaster recovery solutions, and designing scalable network infrastructure. Passionate about streamlining operations through automation and maintaining robust, secure systems.";

// Skills
export const skills = {
  "Cloud & Infrastructure": [
    "Microsoft Azure (Intune, Entra ID)",
    "Microsoft 365",
    "AWS",
    "VMware",
    "Veeam Backup & Replication",
  ],
  "Systems & Networking": [
    "Windows Server",
    "SCCM",
    "VPN Configuration",
    "Firewall Management (Watchguard)",
    "Network Monitoring & Troubleshooting",
    "ISO 27001 Compliance",
  ],
  "Programming & Automation": [
    "PowerShell",
    "Python",
    "HTML/CSS",
  ],
  "Tools": [
    "Microsoft Office Suite",
    "Power BI",
    "SQL Server (SSRS, PBRS)",
    "Adobe Creative Cloud",
  ],
};

// Projects
export const projects = [
  {
    id: 1,
    title: "Enterprise Microsoft 365 & Entra ID Management",
    description: "Managed enterprise-level Microsoft 365 environment with full identity & access management through Entra ID, Intune, Exchange Online, and SharePoint. Implemented security policies and automated provisioning workflows.",
    impact: "Reduced manual provisioning time by 60% through PowerShell automation",
    tags: ["Microsoft 365", "Entra ID", "PowerShell", "ISO 27001"],
    icon: "Shield",
  },
  {
    id: 2,
    title: "Backup & Disaster Recovery Implementation",
    description: "Designed and implemented comprehensive backup strategy using Veeam Backup & Replication 12. Created disaster recovery procedures ensuring data integrity across on-premises and virtual infrastructure.",
    impact: "Achieved 99.9% data recovery success rate with rapid restore capabilities",
    tags: ["Veeam", "Disaster Recovery", "VMware", "Data Integrity"],
    icon: "Database",
  },
  {
    id: 3,
    title: "Network Infrastructure Design & Optimization",
    description: "Designed and deployed scalable network infrastructure with Watchguard firewall policies, VPN configuration for secure remote access, and VMware virtual infrastructure maintenance.",
    impact: "Improved network uptime to 99.95% and reduced security incidents by 40%",
    tags: ["Watchguard", "VMware", "VPN", "Network Design"],
    icon: "Network",
  },
  {
    id: 4,
    title: "Automation & Process Optimization",
    description: "Created comprehensive PowerShell scripts for automating user provisioning, system monitoring, and reporting workflows. Streamlined IT operations across the organization.",
    impact: "Saved 15+ hours per week through automated provisioning and monitoring",
    tags: ["PowerShell", "Automation", "SCCM", "Monitoring"],
    icon: "Terminal",
  },
  {
    id: 5,
    title: "FileShare Online — Self-Hosted File Sharing Platform",
    description: "Full-stack SaaS file sharing platform with secure uploads, expiring share links, batch transfers, file requests, and tiered subscription plans (Free/Plus/Business) with Stripe payments. JWT authentication, admin panel, and automated file cleanup.",
    impact: "Live production app — running on this very domain at /fileshares",
    tags: ["React", "FastAPI", "MongoDB", "Stripe", "JWT Auth"],
    icon: "Share2",
    liveUrl: "/fileshares",
  },
];

// Experience
export const experience = [
  {
    id: 1,
    role: "IT Systems Administrator",
    company: "Results Direct",
    location: "Melbourne",
    period: "Nov 2023 — July 2026",
    highlights: [
      "Managing enterprise Microsoft 365 environment and Watchguard firewall policies",
      "Implemented Veeam Backup & Replication 12 for disaster recovery",
      "Automated provisioning and monitoring with PowerShell scripts",
      "Led ISO 27001 documentation and compliance preparation",
    ],
  },
  {
    id: 2,
    role: "Network Engineer",
    company: "Swinburne University",
    location: "Melbourne",
    period: "Feb 2023 — Nov 2023",
    highlights: [
      "Designed and deployed scalable network infrastructure",
      "Managed vendor relationships and multi-vendor troubleshooting",
      "Implemented network monitoring tools and quality audit procedures",
    ],
  },
  {
    id: 3,
    role: "IT Network Administrator",
    company: "ASN",
    location: "India",
    period: "Apr 2021 — Dec 2021",
    highlights: [
      "Engineered end-to-end route-based IP network solutions",
      "Created VPN infrastructure for secure remote access",
      "Managed SCCM for monitoring, updates, and patching",
    ],
  },
];

// Certifications
export const certifications = [
  {
    id: 1,
    title: "AWS Cloud Solutions Architect",
    issuer: "Amazon Web Services",
    status: "Completed",
  },
  {
    id: 2,
    title: "System Administration & IT Infrastructure",
    issuer: "Google",
    status: "Completed",
  },
  {
    id: 3,
    title: "ITIL Foundation",
    issuer: "ITIL",
    status: "In Progress",
  },
];

// Education
export const education = [
  {
    id: 1,
    degree: "Professional Year",
    institution: "Performance Education, Melbourne",
    period: "Mar 2024 — Present",
  },
  {
    id: 2,
    degree: "Bachelor of Computer Science",
    institution: "Swinburne University, Melbourne",
    period: "Feb 2021 — Dec 2023",
  },
];

// Testimonials
export const testimonials = [
  {
    id: 1,
    name: "Harika Yenduri",
    text: "Nakshtra is an exceptional IT professional who consistently delivers reliable infrastructure solutions. His attention to detail and proactive approach make him a valuable team member.",
    note: "Contact available on request",
  },
  {
    id: 2,
    name: "Ben Cowan",
    text: "Working with Nakshtra was a pleasure. His expertise in cloud environments and automation significantly improved our operational efficiency.",
    note: "Contact available on request",
  },
];
